import { LocalStorageReactive } from '@adornis/base/rxjs-extension/index.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import type { ChemistryControllerHost } from '@adornis/chemistry/controllers/chemistry-controller.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { combineLatest, map } from 'rxjs';

export const activeToken = new LocalStorageReactive('logistik_active_token', '');
export const currentUserHasRestrictedAccess = (host: ChemistryControllerHost) =>
  new RXController(host, combineLatest([activeToken, currentUser()]), obs$ =>
    obs$.pipe(map(([token, currentUser]) => !currentUser && token && !isNaN(+token))),
  );
